/* import __COLOCATED_TEMPLATE__ from './timestamp-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {
    formattedDate: string;
    isDelayed?: boolean;
    isCustomerTimezoneEnabled?: boolean;
  };
  Blocks: {
    default: [];
  };
}

const TimestampTooltip = templateOnlyComponent<Signature>();
export default TimestampTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::TimestampTooltip': typeof TimestampTooltip;
    'inbox2/common/timestamp-tooltip': typeof TimestampTooltip;
  }
}
